import { useEffect } from "react";

const ZARAZ_SESSION_KEY = "zaraz_tracked";

export const useZarazTracking = () => {
  useEffect(() => {
    if (sessionStorage.getItem(ZARAZ_SESSION_KEY)) return;
    try {
      const g = globalThis as typeof globalThis & {
        zaraz?: { track: (name: string, data: { page: string }) => void };
      };
      if (g.zaraz) {
        g.zaraz.track("pageview", { page: globalThis.location?.pathname });
        sessionStorage.setItem(ZARAZ_SESSION_KEY, "1");
      }
    } catch {
      // Zaraz missing or track threw (local dev, non-Cloudflare)
    }
  }, []);
};
